import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';

const Legal = () => {
  usePageTitle('Mentions légales');
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header />
      <div className="flex-1 container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">Mentions légales</h1>
        <p className="mb-4">Informations légales concernant le service PulseCIO.</p>

        <h2 className="font-semibold mt-4">Éditeur</h2>
        <p className="mb-2">PulseCIO — édité et développé par Mathieu Lalande (auto-entreprise). Toutes les informations publiées sur ce site relèvent de la responsabilité de l'auteur.</p>

        <h2 className="font-semibold mt-4">Statut juridique</h2>
        <p className="mb-2">Statut : auto-entreprise (micro-entrepreneur). Pas de capital social à déclarer pour ce statut.</p>

        <h2 className="font-semibold mt-4">Hébergeur</h2>
        <p className="mb-2">Le site est hébergé par Hostinger (https://www.hostinger.com).</p>

        <h2 className="font-semibold mt-4">Contact</h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          Pour toute question, contactez-nous à{' '}
          <a href="mailto:contact@pulsecio.com" className="text-blue-600 dark:text-blue-400 hover:underline">
            contact@pulsecio.com
          </a>
        </p>
        
        <h2 className="font-semibold mt-6">Informations administratives</h2>
        <div className="mb-2">
          <p><strong>MONSIEUR</strong> MATHIEU LALANDE</p>
          <p><strong>SIREN :</strong> 940 937 311</p>
          <p><strong>SIRET DU SIÈGE SOCIAL :</strong> 940 937 311 00014</p>
          <p><strong>DATE DE CRÉATION :</strong> 15 février 2025</p>
          <p><strong>ACTIVITÉ (NAF / APE) :</strong> Programmation informatique - 6201Z</p>
          <p><strong>FORME JURIDIQUE :</strong> Entrepreneur individuel</p>
        </div>

        <h2 className="font-semibold mt-4">Directeur de publication</h2>
        <p className="mb-2">Le directeur de publication du site est Mathieu Lalande, responsable de l'édition des contenus.</p>

        <p className="text-sm text-gray-600 dark:text-gray-400 mt-4">Dernière mise à jour : 9 janvier 2026</p>

        <p className="mt-6"><Link to="/" className="text-accent underline">Retour à l'accueil</Link></p>
      </div>
      <Footer />
    </div>
  );
};

export default Legal;
